import { Button } from "@/components/ui/UIElements/Button";
import React from "react";
import { useTranslation } from "react-i18next";
import { Checkbox } from "../../UIElements/SelectionControl";

const CopyTimesDropdown = ({
  days = [],
  excludeIndex,
  selectedTargets = [],
  onToggleTarget,
  onApply,
  onCancel,
}) => {
  const { t } = useTranslation("common");
  return (
    <div className="border-border bg-card absolute top-8 right-0 z-20 w-56 rounded-lg border shadow-lg sm:top-10">
      <div className="border-border text-foreground border-b px-3 py-2 text-xs">
        {t("schedule.copyTo")}
      </div>
      <div className="max-h-64 space-y-1 overflow-y-auto p-2">
        {days.map(
          (dayLabel, index) =>
            index !== excludeIndex && (
              <label
                key={dayLabel}
                className="text-foreground hover:bg-secondary flex cursor-pointer items-center space-x-2 rounded px-2 py-1 text-xs sm:text-sm"
              >
                <Checkbox
                  checked={selectedTargets.includes(index)}
                  onChange={() => onToggleTarget(index)}
                  className="h-3 w-3"
                />
                <span>{dayLabel}</span>
              </label>
            ),
        )}
      </div>
      <div className="border-border flex items-center justify-between border-t px-3 py-2">
        <Button
          variant="ghost"
          onClick={onCancel}
          className="text-foreground text-xs hover:text-white"
        >
          {t("actions.cancel")}
        </Button>
        <Button
          variant="ghost"
          aria-label={t("schedule.applyCopy")}
          onClick={onApply}
          disabled={selectedTargets.length === 0}
          className={`rounded px-3 py-1 text-xs ${selectedTargets.length === 0 ? "bg-secondary text-muted-foreground" : "hover:bg-muted bg-white text-black"}`}
        >
          {t("schedule.apply")}
        </Button>
      </div>
    </div>
  );
};

export default CopyTimesDropdown;
